var React = require('react');

function LogoIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#e41e25","fillRule":"nonzero","d":"M1.882 38.114h36.237V1.879H1.882v36.235zm37.178.941v-.941.941zM0 39.995V0h40v39.995H0z","key":0}),React.createElement("path",{"fill":"#e41e25","fillRule":"nonzero","d":"M23.429 27.895v-6.547h-6.88v6.547h-3.074v-15.79h3.074v6.348h6.88v-6.348h3.096v15.79h-3.096z","key":1})]);
}

LogoIcon.defaultProps = {"width":"40","height":"40","fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","className":"logoIcon","clipRule":"evenodd"};

module.exports = LogoIcon;

LogoIcon.default = LogoIcon;
